import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  // apiUrl: string = environment.API_SERVER;
  apiUrl: string = environment.PROCUREMENT_API_SERVER;
  constructor(private _httpClient: HttpClient) {}
  data: any;
  docTemplate: any;
  procDocId: any;
  procItemDocId;
  getAllDocuments(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/doc-template/get-all-doc-templates/`,
      { params: payload.params }
    );
  }
  getAllLotTenderDocuments(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/doc-template/get-all-lot-tender-doc-templates/`,
      { params: payload.params }
    );
  }
  getVersionId(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/doc-template/get-default-template-version/${payload.docTemplateId}`
    );
  }
  getAppropriationDoc(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/documents/get-document/${payload.documentId}`
    );
  }
  getContractDoc(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/awarded-lot-doc/${payload.lotId}/type/${payload.documentTypeId}`
    );
  }
  getCompletionDoc(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/lot-implementation-doc/${payload.lotId}/type/${payload.documentTypeId}`
    );
  }

  deleteContractDoc(payload): Observable<any> {
    return this._httpClient.delete(
      `${this.apiUrl}/awarded-lot-doc/${payload.lotId}/${payload.procDocId}`
    );
  }

  deleteDocument(payload): Observable<any> {
    return this._httpClient.delete(
      `${this.apiUrl}/documents/delete-document/${payload.documentId}`
    );
  }

  getAllAppropriationDocs(payload): Observable<any> {
    return this._httpClient.get(`${this.apiUrl}/documents/get-all-documents/`, {
      params: payload.params,
    });
  }
  createProcurementDocument(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/proc-doc/${payload.templateVersionId}`,
      payload.body
    );
  }

  createProcurementItemDocument(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/proc-item-doc/${payload.procItemId}`,
      payload.body
    );
  }

  createProcurementItemDocumentFromTemplate(payload: any): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/proc-item-doc/${payload.procItemId}/type/${payload.templateTypeId}/version/${payload.templateVersionId}`,
      payload.body
    );
  }

  createAwardDocumentFromTemplate(payload: any): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/awarded-lot-doc/${payload.lotId}/bidder/${payload.bidderId}/type/${payload.templateTypeId}/version/${payload.templateVersionId}`,
      payload.body
    );
  }

  createImplementationDocumentFromTemplate(payload: any): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/lot-implementation-doc/${payload.lotId}/bidder/${payload.bidderId}/type/${payload.templateTypeId}/version/${payload.templateVersionId}`,
      payload.body
    );
  }

  createLotDocumentFromTemplate(payload: any): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/lot-doc/${payload.lotId}/type/${payload.templateTypeId}/version/${payload.templateVersionId}`,
      payload.body
    );
  }

  createAdvertDocumentFromTemplate(payload: any): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/procurement-advert-doc/${payload.procurementAdvertId}/type/${payload.templateTypeId}/version/${payload.templateVersionId}`,
      payload.body
    );
  }

  createProcurementItemDocumentFromExistingDocument(
    procItemId: string,
    procDocId: string,
    body: any
  ): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/proc-item-doc/${procItemId}/doc/${procDocId}`,
      body
    );
  }

  createLotDocumentFromExistingDocument(
    lotId: string,
    procDocId: string,
    body: any
  ): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/lot-doc/${lotId}/doc/${procDocId}`,
      body
    );
  }

  createAdvertDocumentFromExistingDocument(
    advertId: string,
    procDocId: string,
    body: any
  ): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/procurement-advert-doc/${advertId}/doc/${procDocId}`,
      body
    );
  }

  createAwardedLotDocumentFromExistingDocument(
    lotId: string,
    procDocId: string,
    body: any
  ): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/awarded-lot-doc/${lotId}/doc/${procDocId}`,
      body
    );
  }

  createImplementationDocumentFromExistingDocument(
    lotId: string,
    procDocId: string,
    body: any
  ): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/lot-implementation-doc/${lotId}/doc/${procDocId}`,
      body
    );
  }

  uploadProcurementDocument(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/proc-item-doc/upload/${payload.procItemId}/type/${payload.templateTypeId}/`,
      payload.formData
    );
  }
  uploadLotDocument(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/lot-doc/upload/${payload.lotId}/type/${payload.templateTypeId}/`,
      payload.formData
    );
  }
  uploadAdvertDocument(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/procurement-advert-doc/upload/${payload.procAdvertId}/type/${payload.templateTypeId}`,
      payload.formData
    );
  }
  uploadAwardDocument(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/awarded-lot-doc/upload/${payload.lotId}/${payload.documentTypeId}`,
      payload.formData
    );
  }

  uploadAImplementationDocument(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/lot-implementation-doc/upload/${payload.lotId}/${payload.documentTypeId}`,
      payload.formData
    );
  }

  createAImplementationDocument(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/lot-implementation-doc/${payload.lotId}/${payload.biddingStageId}/${payload.bidderId}/${payload.deliveryId}?documentType=${payload.documentTypeId}`,
      payload.body
    );
  }
  createAwardDocument(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/awarded-lot-doc/${payload.lotId}/${payload.biddingStageId}/${payload.bidderId}?documentType=${payload.documentTypeId}`,
      payload.body
    );
  }

  createLotItemDocument(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/lot-doc/${payload.lotId}`,
      payload.body
    );
  }
  createAdvertItemDocument(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/procurement-advert-doc/${payload.procurementAdvertId}`,
      payload.body
    );
  }
  updateProcurementDocument(payload): Observable<any> {
    return this._httpClient.put(
      `${this.apiUrl}/proc-doc/update-template-data/${payload.procDocId}/${payload.dataFieldId}`,
      payload.body
    );
  }

  updateProcurementDoc(payload): Observable<any> {
    return this._httpClient.put(
      `${this.apiUrl}/proc-doc/edit-proc-doc/${payload.procDocId}`,
      payload.body
    );
  }

  getProcurementDocument(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/public/tender/proc-docs?procDocIds=${payload.procDocId}`
    );
  }
  getLotRequiredProcurementDocument(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/public/tender/required-documents/${payload.lotId}/${payload.biddingStageId}`
    );
  }
  getAllProcurementDocuments(payload): Observable<any> {
    return this._httpClient.get(`${this.apiUrl}/proc-doc/get-all-proc-docs/`, {
      params: payload.params,
    });
  }
  getDocumentProgressReport(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/proc-doc/document-generation-progress/${payload.proccessId}`
    );
  }

  // downloadProcurementDocument(payload): Observable<any> {
  //   return this._httpClient.get(
  //     `${this.apiUrl}/proc-doc/generate-document/${payload.procDocId}`,responseType: 'blob',
  //   );
  // }
  downloadProcurementDocument(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/proc-doc/generate-document/${payload.procDocId}`,
      {
        observe: 'response',
        responseType: 'blob',
      }
    );
  }

  downloadTemplateProcurementDocument(
    procDocId: string,
    extension: string = 'pdf'
  ): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/public/tender/proc-docs/generate?procDocId=${procDocId}&extension=${extension}`,
      {
        observe: 'response',
        responseType: 'blob',
      }
    );
  }

  downloadUploadedDocument(documentId: string): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/document/download/${documentId}`,
      {
        observe: 'response',
        responseType: 'blob',
      }
    );
  }

  getFileBlob(
    objectId: string,
    uploaded: boolean
  ): Observable<{ blob: Blob; extension: string }> {
    return new Observable<any>((observer) => {
      let request: Observable<any>;
      if (uploaded) {
        request = this.downloadUploadedDocument(objectId);
      } else {
        request = this.downloadTemplateProcurementDocument(objectId);
      }
      request.subscribe({
        next: (res: any) => {
          console.log(res, 'result');
          const blob = new Blob([res.body], {
            type: res.body.type,
          });
          // Determine the file extension based on Content-Type header
          const contentType = blob.type;
          let extension = 'pdf'; // Default extension
          if (contentType) {
            const parts = contentType.split('/');
            if (parts.length === 2) {
              extension = parts[1];
            }
          }
          observer.next({ blob, extension });
          observer.complete();
        },
        error: (error: any) => {
          console.log(error, 'error');
          observer.error(error);
        },
      });
    });
  }

  private handleResponse(res: any, observer: any) {
    let blob: Blob;
    let extension = 'pdf'; // Default to PDF

    if (res instanceof Blob) {
      blob = res;
    } else if (res.body instanceof Blob) {
      blob = res.body;
    } else if (
      typeof res.body === 'string' ||
      (res.error && typeof res.error.text === 'string')
    ) {
      const content = res.body || (res.error && res.error.text);
      // Check if the content starts with '%PDF'
      if (content.startsWith('%PDF')) {
        blob = new Blob([content], { type: 'application/pdf' });
      } else {
        blob = new Blob([content], { type: 'application/octet-stream' });
      }
    } else {
      console.error('Unexpected response format:', res);
      observer.error(new Error('Unexpected response format'));
      return;
    }

    // Log blob details for debugging
    console.log('Blob size:', blob.size);
    console.log('Blob type:', blob.type);
    // Ensure the blob type is set to 'application/pdf' for PDFs
    if (blob.type !== 'application/pdf' && extension === 'pdf') {
      blob = blob.slice(0, blob.size, 'application/pdf');
    }
    observer.next({ blob, extension });
    observer.complete();
  }

  generateMultipleProcurementDocument(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/proc-doc/generate-multiple-documents/`,
      payload.body
    );
  }
  downloadProcurementDocumentPDF(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/proc-doc/generate-document/${payload.procDocId}?extension=pdf`,
      {
        observe: 'response',
        responseType: 'blob',
      }
    );
  }
  exportProcDocSinglePdf(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/proc-doc/generate-documents/${payload.procDocId}?extension=pdf`,
      payload.body
    );
  }
  exportProcDocSingleDocx(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/proc-doc/generate-documents/${payload.procDocId}`,
      payload.body
    );
  }
  generateProcDocDocument(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/public/tender/proc-docs/generate?procDocId=${payload.procDocId}`,
      payload.body
    );
  }
  exportProcDocMergedPdf(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/proc-doc/generate-merged-documents/${payload.procDocId}?extension=pdf`,
      payload.body
    );
  }
  exportProcDocMergedDocx(payload): Observable<any> {
    return this._httpClient.post(
      `${this.apiUrl}/proc-doc/generate-merged-documents/${payload.procDocId}`,
      payload.body
    );
  }

  downloadDocumentPdf(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/document/download/${payload.documentId}`,
      {
        observe: 'response',
        responseType: 'blob',
      }
    );
  }

  downloadDocumentDoc(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/document/download/${payload.documentId}`,
      {
        observe: 'response',
        responseType: 'blob',
      }
    );
  }

  getDocumentFields(procDocId: string): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/proc-doc/${procDocId}/get-item-fields`
    );
  }

  getProcItemProcDocs(procItemId: string) {
    return this._httpClient.get(
      `${this.apiUrl}/proc-doc/get-proc-item-proc-docs/${procItemId}`
    );
  }

  searchAllProjectProcDocs(procItemId: string, params: any) {
    return this._httpClient.get(
      `${this.apiUrl}/proc-doc/get-proc-item-proc-docs/${procItemId}`,
      { params }
    );
  }

  updateTemplateDocumentFields(procDocId: string, payload: any, params?: any) {
    return this._httpClient.put(
      `${this.apiUrl}/proc-doc/${procDocId}/save-form`,
      payload,
      { params }
    );
  }

  searchDocumentFieldHistory(params: any) {
    return this._httpClient.get(`${this.apiUrl}/item-field-history/all/`, {
      params,
    });
  }

  getAllAwardedLotDoc(payload): Observable<any> {
    return this._httpClient.get(`${this.apiUrl}/awarded-lot-doc/`, {
      params: payload.params,
    });
  }

  updateItemFieldApprovalStatus(
    templateItemFieldId: string,
    approvalStatus: string
  ): Observable<any> {
    return this._httpClient.put(
      `${this.apiUrl}/proc-doc/update-approval-status/${templateItemFieldId}/${approvalStatus}`,
      {}
    );
  }
}
